import CheckoutCTAButton from '../../components/shared/CheckoutCTAButton';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { connect } from 'react-redux';
import { completeApplePaySection } from '../../actions/checkoutPaymentActions';

const CheckoutApplePaySubmit = ({ onCompleteApplePaySection }) => {
    return (
        <CheckoutCTAButton
            onClick={onCompleteApplePaySection}
            marginTop
            size="large"
            label={
                <FormattedMessage
                    id="checkout.CheckoutApplePay.applePayContinue"
                    defaultMessage="Continue"
                />
            }
        />
    );
};

CheckoutApplePaySubmit.propTypes = {
    onCompleteApplePaySection: PropTypes.func.isRequired,
};

const ConnectedCheckoutApplePaySubmit = connect(
    () => {
        return {};
    },
    {
        //actions
        onCompleteApplePaySection: completeApplePaySection,
    }
)(CheckoutApplePaySubmit);

export default ConnectedCheckoutApplePaySubmit;
